'use client';

import { Label } from '../typography';
import { Pagination, PaginationContent, PaginationItem, PaginationNext, PaginationPrevious } from '../components/Pagination';

import type { TablePagination } from './types';

export type PaginationFooterProps = Partial<TablePagination> & {
  skeleton?: boolean;
  disabled?: boolean;
  totalCountLabel?: string;
};

const PaginationFooter = (props: PaginationFooterProps): React.ReactElement | null => {
  const { skeleton, disabled, onNextPage, onPrevPage, hasNextPage, hasPrevPage, totalCount, totalCountLabel } = props;

  if (hasNextPage === false && hasPrevPage === false && !skeleton && !disabled) {
    return null;
  }

  return (
    <Pagination className="border-t pt-4 sm:px-0">
      <PaginationContent className="w-full items-center justify-between">
        <PaginationItem>
          <PaginationPrevious disabled={disabled || !hasPrevPage} onClick={() => hasPrevPage && onPrevPage?.()} />
        </PaginationItem>

        {/* `totalCount &&` would render a bare "0" into the footer, since React prints
            the number rather than treating it as "nothing to show" — which is what an
            endpoint that doesn't return a count looks like. A count is shown only when
            there is one to show. */}
        {!disabled && !!totalCount && (
          <Label className="text-content-secondary">{`${totalCount} ${totalCountLabel || 'items'}`}</Label>
        )}

        <PaginationItem>
          <PaginationNext disabled={disabled || !hasNextPage} onClick={() => hasNextPage && onNextPage?.()} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};

export default PaginationFooter;
